export default {
    install() {
        const files = require.context('./', false, /\.js$/, 'sync');
        files.keys().forEach(key => {
            const module = files(key).default;
            !module.install && module();
        });
    }
};
